import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'

import { requiresAuthentication } from '../redux/modules/authentication'

export class Authenticated extends React.Component {
  componentWillMount() {
    this.props.requiresAuthentication(this.props.location.pathname)
  }

  componentWillUpdate(nextProps) {
    this.props.requiresAuthentication(nextProps.location.pathname)
  }

  render() {
    return this.props.children
  }
}

Authenticated.propTypes = {
  children: Pt.node,
  location: Pt.shape({
    pathname: Pt.string,
  }).isRequired,
  requiresAuthentication: Pt.func.isRequired,
}

export default connect(null, { requiresAuthentication })(Authenticated)



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/Authenticated.jsx